var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailSignupMobile = function SvgEmailSignupMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 273,
    viewBox: "0 0 377 273",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.771 272.112h-36.157v-50.631l-86.105-76.972-86.123 76.972v50.631h-36.157v-66.795L304.509 96l122.262 109.317v66.795z",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.807 40v-5.914h-8.282l-12.59-14.084 12.59-14.088h8.282V0h-10.926L333 20.002 350.881 40h10.926zM0 40v-5.914h8.282l12.59-14.084L8.282 5.914H0V0h10.926l17.88 20.002L10.927 40H0z"
  })));
};
export default SvgEmailSignupMobile;